import axiosClient from "./axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const addressApi = {
  generatorAddress: () => {
    const url = "/addresses/init";
    return axiosClient.get(url);
  },

  getAddress: (params) => {
    const url = "/addresses";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getShippingAddress: (params) => {
    const url = "/shipping-address";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  createAddress: (params) => {
    const url = "/shipping-address";
    const payload = CheckNullParams(params);

    return axiosClient.post(url, payload);
  },
  updateAddress: (id, params) => {
    const url = "/shipping-address/";
    const payload = CheckNullParams(params);
    return axiosClient.post(url + id, payload);
  },
  deleteAddress: (id) => {
    const url = "/shipping-address";
    return axiosClient.delete(url + id);
  },
  deleteAddresss: (params) => {
    const url = "/shipping-address";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default addressApi;
